<template>
  <div class="leave-form-wrap">
    <!-- 申请详情列表 -->
    <!-- <van-nav-bar
      left-arrow
      @click-left="clickBack"
      right-text="我要申请"
      @click-right="$router.push('/inAndOutSchool')"
    >
    </van-nav-bar> -->

    <div class="form-wrap" v-for="item in list" :key="item.id" @click="jump(item.id)">
      <div class="form-wrap_item">
        <h4>{{item.title}}</h4>
        <span :class="['span_dsp','span_ysp','span_wtg'][item.auditStatus]">{{['待审批','已审批','已驳回'][item.auditStatus]}}</span>
      </div>
       <span>申请时间 : {{dateMoment(item.applyTime)}}</span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getPassList();
  },
  methods: {
    dateMoment(date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    clickBack() {
      this.$router.go(-1);
    },
    getPassList() {
      this.$https
        .getPassAuditList({
          pageNum: 1,
          pageSize: 1000,
          userId:
            JSON.parse(localStorage.getItem("userInfo")) &&
            JSON.parse(localStorage.getItem("userInfo")).id,
        })
        .then(({ data, code }) => {
          if (code != 200) {
            this.$toast("获取列表失败");
          } else {
            if (data.list.length == 0) {
              this.$toast("暂无申请历史");
            } else {
              this.list = data.list;
            }
          }
        });
    },
    jump(id) {
      this.$router.push(`/inAndOutSchoolAuditList?type=au&id=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.leave-form-wrap {
  padding-bottom: 4rem;
  position: relative;
  //   height: 100vh;
  //   overflow: hidden;
  .handle_btn {
    display: flex;
    position: fixed;
    right: 1rem;
    padding: 1rem 0;
    left: 1rem;
    bottom: 0;
    // background-color: #fff;
    justify-content: space-between;
    .van-button {
      width: 48%;
    }
  }
}

.form-wrap {
  margin: 1rem 0.5rem 1rem;

  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
  align-items: flex-start;
  padding: 1rem 1rem;
  .form-wrap_item {
    justify-content: space-between;
    align-items: center;
    display: flex;
    margin-bottom: 0.5rem;
    .span_dsp {
      display: inline-block;
      border: solid 1px #1b88f9;
      color: #1b88f9;
      padding: 0 1px;
      border-radius: 2px;
    }
    .span_ysp {
      display: inline-block;
      border: solid 1px #1fb315;
      color: #1fb315;
      padding: 0 1px;
      border-radius: 2px;
    }
    .span_wtg {
      display: inline-block;
      border: solid 1px #ee0a24;
      color: #ee0a24;
      padding: 0 1px;
      border-radius: 2px;
    }
  }
  h4 {
    font-size: 0.94rem;
  }
  span {
    font-size: 0.8rem;
    color: #959599;
  }
}
</style>
